<template>
    <ul class="tag-class-wrap">
        <li v-for="item in data" :key="item.id" class="tag-item" :class="[selectId == item.id ? 'active' : '']" @click="tagClick(item)">
            <div class="tag-title">
                <span class="name">{{ item.name }}</span>
                <span class="id">类型ID：{{ item.id }}</span>
            </div>
            <div class="tag-desc">
                <span class="desc">{{ item.describe }}</span>
                <el-tag type="info">{{ tagType[item.type] }}</el-tag>
            </div>
            <div class="tag-btn" @click.stop>
                <TagEdit :data="{ type: 'edit', tagData: item }" @submit="submitClick">
                    <el-button slot="dialogBtn" size="mini" class="icon-edit" icon="el-icon-edit" />
                </TagEdit>
                <el-button size="mini" class="icon-delete" icon="el-icon-delete" @click="deleteClick(item)" />
            </div>
        </li>
    </ul>
</template>

<script>
import TagEdit from "./TagEdit.vue";
import { delTagClass } from "../server";

export default {
    name: "TagList",
    components: {
        TagEdit
    },
    props: {
        data: {
            type: Array,
            default() {
                return [];
            }
        },
        selectId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            tagType: {
                1: "条件标签",
            },
        };
    },
    methods: {
        tagClick(data) {
            this.$emit("click", data);
        },
        submitClick() {
            this.$emit("change");
        },
        deleteClick(data) {
            this.$confirm("您确认删除该分类吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                delTagClass({ ids: data.id, gameId: this.$store.state.zhiji.gameState.gameId }).then(() => {
                    this.$emit("change");
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.tag-class-wrap {
    .tag-item {
        padding: 15px 16px;
        position: relative;
        &:hover {
            background: rgba(217, 235, 246, 0.7);
            cursor: pointer;
            .tag-btn {
                display: flex;
                .icon-edit,
                .icon-delete {
                    font-size: 16px;
                }
            }
        }
        .tag-title {
            display: flex;
            justify-content: space-between;
            margin-bottom: 6px;
            .name {
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .id {
                color: #9b9ba3;
                flex-shrink: 0;
                flex-grow: 0;
            }
        }
        .tag-desc {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .desc {
                width: 70%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .tag-btn {
            display: none;
            justify-content: center;
            align-items: center;
            position: absolute;
            width: 110px;
            height: 100%;
            right: 0;
            top: 0;
            background: #fbfbff;
            /deep/.el-button {
                border: none;
                background: transparent;
            }
        }
    }
    .active {
        background: rgba(217, 235, 246, 0.7);
    }
}
</style>
